module.exports = __webpack_public_path__ + "img/store-manage.43e78fa5.png";